
define('text!templates/modules/member/member/lists/member-list.html',[],function () { return '<div class="list-content">\n    <div class="separator">\n        <h3><span class="{{icon}}"></span> {{#t}}{{title}}{{/t}} <span class="total">(<span data-bind="text:stateTotal"></span>)</span></h3>\n    </div>\n    <div class="member-list"></div>\n</div>\n';});

